import { ReactElement } from 'react';
import type { AutocompleteProps } from '@mantine/core';
import { Autocomplete as MantineAutocomplete } from '@mantine/core';

export const Autocomplete = (props: AutocompleteProps): ReactElement => {
  return <MantineAutocomplete {...props} />;
};
